"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const components = __importStar(require("../components"));
const lodash_1 = require("lodash");
function Styleguide() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "styleguide", children: [(0, jsx_runtime_1.jsxs)("nav", { className: "side-navigation-styleguide", children: [(0, jsx_runtime_1.jsx)("h5", { children: "Styleguide" }), (0, jsx_runtime_1.jsx)("ul", { children: (0, lodash_1.map)(components, (Component, name) => ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { href: `#${name}`, children: (0, lodash_1.startCase)(name) }) }, name))) })] }), (0, jsx_runtime_1.jsx)("main", { className: "content with-sidebar styleguide", children: (0, lodash_1.map)(components, (Component, name) => ((0, jsx_runtime_1.jsxs)("div", { id: name, className: "styleguide-card", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, lodash_1.startCase)(name) }), (0, jsx_runtime_1.jsx)(Component, {})] }, name))) })] }));
}
function mapStateToProps() {
    return {};
}
const mapDispatchToProps = {};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(Styleguide);
